import React from 'react'
import './CancelButton.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons'

interface SubmitButtonProps {
  disabled?: boolean
  onClick?: () => void
  text: string
}

const HuiCancelButton: React.FC<SubmitButtonProps> = ({
  disabled = false,
  onClick,
  text
}) => {
  return (
    <button
      type="button"
      className={`cancel-button ${disabled ? 'disabled' : ''}`}
      disabled={disabled}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faCircleXmark} className="button-icon" />
      <div className="button-text"> {text}</div>
    </button>
  )
}

export default HuiCancelButton
